import getEventsUrl from '../../utils/getEventsUrl/getEventsUrl'
import getFrontendEventsClient from '../getFrontendEventsClient/getFrontendEventsClient'
import { InterstitialAction, InterstitialEvent } from '../../types/InterstitialEvent'

export default function sendInterstitialEvent(locale: string, action: InterstitialAction, params: InterstitialEvent) {
  const eventsUrl = getEventsUrl(locale)
  const frontendEventsClient = getFrontendEventsClient(eventsUrl)

  const eventParams: InterstitialEvent = {
    bespokeId: params.bespokeId,
    clientId: params.legacyOSMClientId,
    locale: `${locale}`.split('/').pop().toUpperCase(),
    type: params.type,
    translation: params.translation,
    error: params.error ? JSON.stringify(params.error, Object.getOwnPropertyNames(params.error)) : undefined,
    k: params.k
  }

  // remove undefined values from object
  // eslint-disable-next-line no-param-reassign
  Object.keys(eventParams).forEach(key => eventParams[key] === undefined && delete eventParams[key])

  frontendEventsClient.event(action, eventParams)
}
